import { TmTransportError } from '@/core/error/transport/tmTransportError'

export class TmCancelRequestError extends TmTransportError {
  public name = 'TmCancelRequestError'
}
